import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import ContentHeading from '../../../shared/commonComponents/ContentHeading';
import VideoPlayer from '../../../shared/commonComponents/VideoPlayer/VideoPlayer';

import { OnboardingAxios, UserActivityAxios } from "../../../API";
import authSlice from '../../../store/auth/authSlice';

const Overview = () => {
    //const [currentSlide, setCurrentSlide] = useState(1);
    const topref = useRef(null);
    const mission = useSelector((state) => state.mission);
    const [activeSlide, setActiveSlide] = useState(0);
    const missionDetails = useSelector((state) => state.auth.missionDetails);
    const [journeyIntro, setJourneyIntro] = useState([]);
    const loggedInUser = useSelector((state) => state.auth.loggedInUser);

    const [showIntro, setShowIntro] = useState(!loggedInUser.overviewVisited);

    const dispatch = useDispatch();

    useEffect(() => {
        setJourneyIntro(missionDetails.metaData);
    }, [missionDetails]);

    const setOverviewVisited = () => {
        OnboardingAxios.get(`OfferingUsers/setoverviewvisited/${loggedInUser.offeringUserId}`)
            .then(function (response) {
                dispatch(authSlice.actions.setOverviewVisited());
            })
            .catch(function (error) {
                console.log(error);
            });

    };


    const addUserActivityLog = (item) => {
        var UAdata = {
            email: loggedInUser.email,
            offeringId: loggedInUser.offeringId,
            missionId: loggedInUser.missionId,
            userId: loggedInUser.userId,
            offeringUserId: loggedInUser.offeringUserId,
            actionType: "Reference Material Links",
            actionName: item.name,
            actionOn: item.action,
        };
        UserActivityAxios.post(`UserActivityLog`, UAdata).then(function (res) {

        }).catch(function (error) {
            console.log(error);
        });
    };

    const [isVideoLogAdded, setIsVideoLogAdded] = useState(true);

    const addVideoUserActivityLog = () => {
        if (isVideoLogAdded) {
            var UAdata = {
                email: loggedInUser.email,
                offeringId: loggedInUser.offeringId,
                missionId: loggedInUser.missionId,
                userId: loggedInUser.userId,
                offeringUserId: loggedInUser.offeringUserId,
                actionType: "Mission Video",
                actionName: "",
                actionOn: "",
            };
            UserActivityAxios.post(`UserActivityLog`, UAdata).then(function (res) {
                setIsVideoLogAdded(false);
            }).catch(function (error) {
                console.log(error);
            });
        }
    }

    return (
        <div className="px-3 py-4 scroll-content journey-overview" ref={topref}>
            {showIntro
                ?
                <div className="journey-intro">
                    <div className="slide-container" id="top">
                        {journeyIntro.length > 0 && <div className="slide-item">
                            <ContentHeading title={journeyIntro[activeSlide].metaName} hideFirst="hidden" />
                            <div className="slide-details" dangerouslySetInnerHTML={{ __html: journeyIntro[activeSlide].metaValue }}></div>
                        </div>
                        }

                        {journeyIntro.length > 0 && <div className="slide-controls">
                            <Button
                                className="nav-btn back-button"
                                disabled={activeSlide == 0 ? true : false}
                                onClick={() => { setActiveSlide(activeSlide - 1); topref.current.scrollTo(0, 0); }} />

                            {activeSlide < (journeyIntro.length - 1)
                                ? <Button className="nav-btn next-button" onClick={() => { setActiveSlide(activeSlide + 1); topref.current.scrollTo(0, 0); }} />
                                : <Button className="cdx-btn btn-outline" onClick={() => { setShowIntro(false); setActiveSlide(0); setOverviewVisited(); topref.current.scrollTo(0, 0); }}>Proceed</Button>
                            }

                        </div>}
                    </div>

                </div>
                :
                <>
                    <div className="intro-button">
                        <Button className='cdx-btn' onClick={() => setShowIntro(true)}>Show Intro</Button>
                    </div>
                    <ContentHeading title={mission.overviewTitle} />
                    <div className="content-padding ">
                        <p className="py-3 m-0 font-14">
                            <div dangerouslySetInnerHTML={{ __html: missionDetails.longDescription }} />
                        </p>
                        {missionDetails.videoPath && <div className="video-player-wrapper">
                            <div className="video-decoration"></div>
                            <div className="video-player-border">
                                <div className="video-player">
                                    <VideoPlayer src={missionDetails.videoPath} type="video/mp4" addVideoUserActivityLog={addVideoUserActivityLog} />
                                </div>
                            </div>
                            <div className="video-decoration custombottom"></div>
                        </div>}
                    </div>
                    {loggedInUser.roleId == 4 && missionDetails.referenceMaterials.length > 0 && <>
                        < ContentHeading title={mission.referenceMaterialTitle} />
                        <div className="content-padding py-4">
                            {missionDetails.referenceMaterials.map(item => {
                                return <div className="material-item" key={item.name}>
                                    <div className="material-details">
                                        <p className="m-0">{item.name}</p>
                                        <a href={item.action} onClick={() => { addUserActivityLog(item); }} className="link-blue" target={item.target}>{decodeURI(item.action.split('/')[item.action.split('/').length - 1])}</a>
                                    </div>
                                </div>;
                            })}

                        </div>
                    </>
                    }

                    {loggedInUser.roleId == 5 && missionDetails.coachOnlyReferenceMaterials.length > 0 && <>
                        < ContentHeading title={mission.referenceMaterialTitle} />
                        <div className="content-padding py-4">
                            {missionDetails.coachOnlyReferenceMaterials.map(item => {
                                return <div className="material-item" key={item.name}>
                                    <div className="material-details">
                                        <p className="m-0">{item.name}</p>
                                        <a href={item.action} onClick={() => { addUserActivityLog(item); }} className="link-blue" target={item.target}>{decodeURI(item.action.split('/')[item.action.split('/').length - 1])}</a>
                                    </div>
                                </div>;
                            })}

                        </div>
                    </>
                    }
                </>
            }
        </div >
    );
};

export default Overview;